module.exports = __webpack_public_path__ + "media/src/ui/icons/iconPaperclip-028f27462e54ea328736d5c276b18750.svg";